
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import { PantrySearchLineInfo } from "@/types/pantry";
import PantrySearchListItem from "./PantrySearchListItem.vue";

export default defineComponent({
  name: "PantrySearchListLineView",
  components: {
    PantrySearchListItem
  },
  props: {
    list: {
      type: PantrySearchLineInfo,
      default: null,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("PantrySearchListLineView list=" + JSON.stringify(props.list));
    const getList = () => {
      return props.list != null ? props.list : null;
    };
    const onSelectRecipe = (id: number, type: string) => {
      context.emit("select-recipe", id, type);
    };
    return {
      getList,
      onSelectRecipe
    };
  }
});
